import axios from "axios";

const api = axios.create({
    baseURL: "/api"
});

api.interceptors.request.use(

    (config)=>{

        const token = localStorage.getItem("accessToken");

        if(token){

            config.headers.Authorization =
                "Bearer " + token;

        }

        return config;

    }

);

// ==========================
// Response Interceptor
// ==========================
api.interceptors.response.use(

    (response) => {

        return response;

    },

    (error) => {

        if (error.response && error.response.status === 401) {

            localStorage.removeItem("accessToken");
            localStorage.removeItem("loginId");
            localStorage.removeItem("userName");
            localStorage.removeItem("role");

            window.location.replace("/login");

            return;
        }

        return Promise.reject(error);

    }

);

export default api;